function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#891818;}.b{fill:#fff;fill-rule:evenodd;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M60,46.535A13.466,13.466,0,0,1,46.535,60H13.465A13.473,13.473,0,0,1,0,46.535V13.465A13.473,13.473,0,0,1,13.465,0h33.07A13.473,13.473,0,0,1,60,13.465Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M116.107,178.2a3.933,3.933,0,0,1-2.589-2.494c-1.118-3.053-1.448-15.826.706-18.343a4.251,4.251,0,0,1,2.825-1.492c5.814-.618,23.81-.536,25.882.21a4.05,4.05,0,0,1,2.542,2.424c1.224,3.158,1.271,14.649-.165,17.691a3.871,3.871,0,0,1-1.824,1.818C141.318,179.147,118.968,179.136,116.107,178.2Zm9.251-5.99,10.487-5.384-10.487-5.419Z",
  transform: "translate(-99.513 -137.179)"
});

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.14aaada0.svg";
export { ForwardRef as ReactComponent };